import { Dialog } from './dialog';
import { Button } from "primereact/button";
import { useId } from 'react';
import DOMPurify from 'dompurify';
import { useFullscreenDialogParent } from '../../general/use-fullscreen-dialog-parent';
import '../../assets/error-dialog.css';

type GeneralErrorDialogProps = {
  visible: boolean;
  message: string;
  details?: string;
  title?: string;
  onClose: () => void;
  parent?: HTMLDivElement | null;
};

export function GeneralErrorDialog({
  visible,
  message,
  details,
  title = "Unable to complete this action",
  onClose,
  parent
}: GeneralErrorDialogProps) {
  const messageId = useId();
  const dialogParent = useFullscreenDialogParent(parent);
  return (
    <Dialog
      header={
        <div className="error-dialog-heading">
          <span className="error-dialog-icon" aria-hidden="true"><i className="pi pi-exclamation-circle" /></span>
          <span>{title}</span>
        </div>
      }
      className="general-error-dialog"
      visible={visible}
      onHide={onClose}
      modal
      draggable={false}
      appendTo={dialogParent}
      aria-describedby={messageId}
      style={{ width: '32rem', maxWidth: 'calc(100vw - 2rem)' }}
      footer={<Button label="Close" onClick={onClose} autoFocus />}
    >
      <div className="error-dialog-body">
        <div id={messageId} className="error-dialog-message" role="alert">
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message, {
            ALLOWED_TAGS: ['p', 'br', 'strong', 'b', 'em', 'i', 'ul', 'ol', 'li', 'code'], ALLOWED_ATTR: [],
          }) }} />
        </div>
        {details && <details className="error-dialog-details" key={message + details}>
          <summary>More details</summary>
          <div className="error-dialog-details-content">{details}</div>
        </details>}
      </div>
    </Dialog>
  );
}
